    <template>
  <footer class="footer">
    © 2019 iRecharge Merchant Service
  </footer>
</template>

    <script>
export default {};
</script>
    <style>
</style>
        